export default "__VITE_ASSET__7dsEaDvL__"